import type { TourSpec } from "./types";
import { dashboardTour } from "./dashboard";
import { flippingTour } from "./flipping";
import { housingTour } from "./housing";
import { dropshipTour } from "./dropship";
import { inventoryTour } from "./inventory";
import { statsTour } from "./stats";
import { tsmTour } from "./tsm";
import { snipeTour } from "./snipe";
import { tsmProfileTour } from "./tsmProfile";
import { settingsRealmTour } from "./settingsRealm";
import { settingsPersonalTour } from "./settingsPersonal";
import { settingsDiscordTour } from "./settingsDiscord";
import { classicDealsTour } from "./classicDeals";

export const TOURS_BY_PATH: Record<string, TourSpec> = {
  "/dashboard": dashboardTour,
  "/tools/classic-deals": classicDealsTour,
  "/tools/flipping": flippingTour,
  "/tools/housing": housingTour,
  "/tools/dropship": dropshipTour,
  "/tools/inventory": inventoryTour,
  "/tools/stats": statsTour,
  "/tools/tsm": tsmTour,
  "/tools/snipe": snipeTour,
  "/guides/tsm-profile": tsmProfileTour,
  "/settings/realm": settingsRealmTour,
  "/settings/personal": settingsPersonalTour,
  "/settings/discord": settingsDiscordTour,
};

export function getTourForPath(pathname: string): TourSpec | null {
  return TOURS_BY_PATH[pathname] ?? null;
}
